var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1771_71125)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29 14.585C29 6.57683 22.5081 0.0849609 14.5 0.0849609C6.49187 0.0849609 0 6.57683 0 14.585C0 21.8223 5.30247 27.821 12.2344 28.9088V18.7764H8.55273V14.585H12.2344V11.3904C12.2344 7.75637 14.3991 5.74902 17.7112 5.74902C19.2977 5.74902 20.957 6.03223 20.957 6.03223V9.60059H19.1286C17.3274 9.60059 16.7656 10.7183 16.7656 11.865V14.585H20.7871L20.1442 18.7764H16.7656V28.9088C23.6976 27.821 29 21.8223 29 14.585Z",
    fill: "#6D89AA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1771_71125"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 29,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoFacebook);
export default __webpack_public_path__ + "static/media/ico-facebook.d0ca7e1833e5643c06a1a8fce24641f6.svg";
export { ForwardRef as ReactComponent };